import { ThemeDrive } from "@geotab/zenith";
import React from "react";
import { useStoreSelector } from "../../../../../ui/framework/hooks/useStoreSelector";
import { useStoreContext } from "../../../../../ui/framework/hooks/StoreContext";

interface IMenuProps {
    children: React.ReactNode;
}

const Menu: React.FC<IMenuProps> = ({
    children
}) => {
    const { store } = useStoreContext();
    const nightMode = useStoreSelector(store, state => state.data.nightMode);

    return (
        <ThemeDrive dark={nightMode}>
        <ul id="footer-menu-list" className="tabbar" role="menubar">
            {children}
        </ul>
        </ThemeDrive>
    );
};

export default Menu;